// @ts-nocheck
import React, { useState, useEffect } from 'react';

export interface CheckboxProps {
  onChange?: (checked: boolean) => void;
  checked?: boolean;
  label?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  title?: string;
}

function Checkbox({ onChange, checked, label, className, disabled, title }: CheckboxProps) {
  const [value, setValue] = useState(checked || false);
  useEffect(() => {
    setValue(checked);
  }, [checked]);

  const handleClick = () => {
    if (!disabled) {
      setValue((prevState) => !prevState);
      onChange(!value);
    }
  };
  return (
    <>
      <span
        className={`${className ? className : ''} checkbox-container ${
          disabled ? 'disabled' : ''
        }`}
        onClick={handleClick}
        title={title}
      >
        <input
          type="checkbox"
          style={{ display: 'inline' }}
          checked={value}
          onChange={handleClick}
          disabled
        />
        <span className="checkmark"></span>
      </span>
      {label && (
        <span className="ms-2 checkbox-label" onClick={handleClick}>
          {' '}
          {label}
        </span>
      )}
    </>
  );
}

export default Checkbox;
